import { setContext } from '@apollo/client/link/context'
import Cookies from 'js-cookie'
import * as _ from 'lodash-es'
import { userTokenKey } from '../../sharedF/cookiesF.mts'

export const gqGetUserToken = () =>  Cookies.get(userTokenKey)

export const authLink = setContext((_ignore, props) => {
  const { headers: origHeaders } = props

  let headers = _.cloneDeep(origHeaders) || {}

  const userToken = gqGetUserToken()

  if (userToken) {
    const authorization = `Bearer ${userToken}`
    Object.assign(headers, {authorization})
  }

  return {headers}
})
